import { motion } from 'framer-motion';
import { useI18n } from '../i18n';

export function PrivacyPage() {
  const { language } = useI18n();
  
  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-900 py-12">
      <div className="max-w-4xl mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white dark:bg-slate-800 rounded-xl shadow-md p-8"
        >
          <h1 className="text-3xl font-bold text-slate-900 dark:text-white mb-8">
            {language === 'sr' ? 'Politika privatnosti' : 'Privacy Policy'}
          </h1>
          
          <div className="prose prose-slate dark:prose-invert max-w-none">
            <p className="text-slate-600 dark:text-slate-400 mb-6">
              {language === 'sr' ? 'Poslednja izmena: 27. januar 2026.' : 'Last updated: January 27, 2026.'}
            </p>

            <h2 className="text-xl font-semibold text-slate-900 dark:text-white mt-8 mb-4">
              {language === 'sr' ? '1. Uvod' : '1. Introduction'}
            </h2>
            <p className="text-slate-600 dark:text-slate-400 mb-4">
              {language === 'sr' 
                ? 'Svoj Na Svom se obavezuje da štiti privatnost svojih korisnika. Ova politika privatnosti objašnjava kako prikupljamo, koristimo, čuvamo i štitimo vaše lične podatke u skladu sa Zakonom o zaštiti podataka o ličnosti Republike Srbije i GDPR regulativom.' 
                : 'Svoj Na Svom is committed to protecting user privacy. This privacy policy explains how we collect, use, store, and protect your personal data in accordance with the Republic of Serbia Personal Data Protection Act and GDPR regulations.'}
            </p>

            <h2 className="text-xl font-semibold text-slate-900 dark:text-white mt-8 mb-4">
              {language === 'sr' ? '2. Podaci koje prikupljamo' : '2. Data We Collect'}
            </h2>
            <h3 className="text-lg font-medium text-slate-800 dark:text-slate-200 mt-4 mb-2">
              {language === 'sr' ? '2.1 Podaci koje nam direktno pružate:' : '2.1 Data you provide directly:'}
            </h3>
            <ul className="list-disc pl-6 text-slate-600 dark:text-slate-400 mb-4 space-y-2">
              <li>{language === 'sr' ? 'Ime i prezime (za fizička lica) ili naziv firme (za pravna lica)' : 'Name (for individuals) or company name (for legal entities)'}</li>
              <li>{language === 'sr' ? 'Email adresa' : 'Email address'}</li>
              <li>{language === 'sr' ? 'Broj telefona' : 'Phone number'}</li>
              <li>{language === 'sr' ? 'Matični broj (za pravna lica - 8 cifara)' : 'Company registration number (for legal entities - 8 digits)'}</li>
              <li>{language === 'sr' ? 'Podaci o nekretninama koje objavljujete' : 'Information about properties you list'}</li>
            </ul>
            <h3 className="text-lg font-medium text-slate-800 dark:text-slate-200 mt-4 mb-2">
              {language === 'sr' ? '2.2 Podaci koje automatski prikupljamo:' : '2.2 Data we collect automatically:'}
            </h3>
            <ul className="list-disc pl-6 text-slate-600 dark:text-slate-400 mb-4 space-y-2">
              <li>{language === 'sr' ? 'IP adresa' : 'IP address'}</li>
              <li>{language === 'sr' ? 'Tip i verzija pretraživača' : 'Browser type and version'}</li>
              <li>{language === 'sr' ? 'Operativni sistem' : 'Operating system'}</li>
              <li>{language === 'sr' ? 'Podaci o korišćenju platforme' : 'Platform usage data'}</li>
              <li>{language === 'sr' ? 'Kolačići (cookies)' : 'Cookies'}</li>
            </ul>

            <h2 className="text-xl font-semibold text-slate-900 dark:text-white mt-8 mb-4">
              {language === 'sr' ? '3. Svrha obrade podataka' : '3. Purpose of Data Processing'}
            </h2>
            <ul className="list-disc pl-6 text-slate-600 dark:text-slate-400 mb-4 space-y-2">
              <li>{language === 'sr' ? 'Kreiranje i upravljanje vašim korisničkim nalogom' : 'Creating and managing your user account'}</li>
              <li>{language === 'sr' ? 'Verifikacija email adrese i identiteta' : 'Email and identity verification'}</li>
              <li>{language === 'sr' ? 'Objavljivanje i prikazivanje vaših oglasa' : 'Publishing and displaying your listings'}</li>
              <li>{language === 'sr' ? 'Omogućavanje komunikacije između korisnika' : 'Enabling communication between users'}</li>
              <li>{language === 'sr' ? 'Procesiranje plaćanja i kupovine tokena' : 'Processing payments and token purchases'}</li>
              <li>{language === 'sr' ? 'Slanje obaveštenja o vašim oglasima i aktivnostima' : 'Sending notifications about your listings and activities'}</li>
              <li>{language === 'sr' ? 'Sprečavanje prevara i zloupotreba' : 'Preventing fraud and abuse'}</li>
            </ul>

            <h2 className="text-xl font-semibold text-slate-900 dark:text-white mt-8 mb-4">
              {language === 'sr' ? '4. Vidljivost kontakt informacija' : '4. Contact Information Visibility'}
            </h2>
            <p className="text-slate-600 dark:text-slate-400 mb-4">
              {language === 'sr' ? 'Radi zaštite vaše privatnosti, primenjujemo sledeća pravila:' : 'To protect your privacy, we apply the following rules:'}
            </p>
            <ul className="list-disc pl-6 text-slate-600 dark:text-slate-400 mb-4 space-y-2">
              <li>{language === 'sr' ? 'Broj telefona je vidljiv samo prijavljenim korisnicima' : 'Phone numbers are visible only to logged-in users'}</li>
              <li>{language === 'sr' ? 'Slanje poruka je dostupno samo verifikovanim korisnicima (potvrđena email adresa)' : 'Messaging is available only to verified users (confirmed email)'}</li>
              <li>{language === 'sr' ? 'Slanje ponuda i licitiranje na aukcijama zahteva verifikovan nalog' : 'Sending offers and auction bidding requires a verified account'}</li>
            </ul>

            <h2 className="text-xl font-semibold text-slate-900 dark:text-white mt-8 mb-4">
              {language === 'sr' ? '5. Funkcija "Zapamti me"' : '5. "Remember Me" Function'}
            </h2>
            <p className="text-slate-600 dark:text-slate-400 mb-4">
              {language === 'sr' ? 'Kada koristite opciju "Zapamti me" prilikom prijave:' : 'When you use the "Remember me" option during login:'}
            </p>
            <ul className="list-disc pl-6 text-slate-600 dark:text-slate-400 mb-4 space-y-2">
              <li>{language === 'sr' ? 'Vaša sesija ostaje aktivna 24 sata bez ponovne prijave' : 'Your session remains active for 24 hours without re-login'}</li>
              <li>{language === 'sr' ? 'Nakon 24 sata, sesija ističe ali se vaša email adresa pamti za lakšu ponovnu prijavu' : 'After 24 hours, the session expires but your email is remembered for easier re-login'}</li>
              <li>{language === 'sr' ? 'Lozinka se nikada ne čuva lokalno' : 'Password is never stored locally'}</li>
            </ul>

            <h2 className="text-xl font-semibold text-slate-900 dark:text-white mt-8 mb-4">
              {language === 'sr' ? '6. Deljenje podataka sa trećim licima' : '6. Sharing Data with Third Parties'}
            </h2>
            <p className="text-slate-600 dark:text-slate-400 mb-4">
              {language === 'sr' ? 'Vaše podatke možemo deliti sa:' : 'We may share your data with:'}
            </p>
            <ul className="list-disc pl-6 text-slate-600 dark:text-slate-400 mb-4 space-y-2">
              <li>{language === 'sr' ? 'Drugim korisnicima platforme (kontakt podaci u oglasima - samo prijavljenim korisnicima)' : 'Other platform users (contact info in listings - only to logged-in users)'}</li>
              <li>{language === 'sr' ? 'Pružaocima usluga plaćanja' : 'Payment service providers'}</li>
              <li>{language === 'sr' ? 'Pružaocima hosting i IT usluga' : 'Hosting and IT service providers'}</li>
              <li>{language === 'sr' ? 'Državnim organima kada je to zakonom propisano' : 'Government authorities when required by law'}</li>
            </ul>
            <p className="text-slate-600 dark:text-slate-400 mb-4 font-medium">
              {language === 'sr' ? 'Ne prodajemo vaše lične podatke trećim licima u marketinške svrhe.' : 'We do not sell your personal data to third parties for marketing purposes.'}
            </p>

            <h2 className="text-xl font-semibold text-slate-900 dark:text-white mt-8 mb-4">
              {language === 'sr' ? '7. Kolačići (Cookies)' : '7. Cookies'}
            </h2>
            <p className="text-slate-600 dark:text-slate-400 mb-4">
              {language === 'sr' ? 'Koristimo kolačiće za:' : 'We use cookies for:'}
            </p>
            <ul className="list-disc pl-6 text-slate-600 dark:text-slate-400 mb-4 space-y-2">
              <li>{language === 'sr' ? 'Održavanje vaše sesije i prijave' : 'Maintaining your session and login'}</li>
              <li>{language === 'sr' ? 'Pamćenje vaših preferencija (jezik, tema)' : 'Remembering your preferences (language, theme)'}</li>
              <li>{language === 'sr' ? 'Funkcionalnost "Zapamti me"' : '"Remember me" functionality'}</li>
              <li>{language === 'sr' ? 'Analitiku i poboljšanje performansi (uključujući Google Analytics)' : 'Analytics and performance improvement (including Google Analytics)'}</li>
            </ul>

            <h2 className="text-xl font-semibold text-slate-900 dark:text-white mt-8 mb-4">
              {language === 'sr' ? '8. Google Analytics' : '8. Google Analytics'}
            </h2>
            <p className="text-slate-600 dark:text-slate-400 mb-4">
              {language === 'sr' 
                ? 'Koristimo Google Analytics za analizu korišćenja sajta. Google Analytics prikuplja:' 
                : 'We use Google Analytics to analyze website usage. Google Analytics collects:'}
            </p>
            <ul className="list-disc pl-6 text-slate-600 dark:text-slate-400 mb-4 space-y-2">
              <li>{language === 'sr' ? 'Informacije o uređaju i pregledaču' : 'Device and browser information'}</li>
              <li>{language === 'sr' ? 'IP adresu (anonimizovanu)' : 'IP address (anonymized)'}</li>
              <li>{language === 'sr' ? 'Lokaciju (na osnovu IP adrese)' : 'Location (based on IP address)'}</li>
              <li>{language === 'sr' ? 'Stranice koje posećujete i vreme provedeno na njima' : 'Pages visited and time spent on them'}</li>
              <li>{language === 'sr' ? 'Izvor saobraćaja' : 'Traffic source'}</li>
            </ul>
            <p className="text-slate-600 dark:text-slate-400 mb-4">
              {language === 'sr' 
                ? 'Možete onemogućiti Google Analytics instaliranjem Google Analytics Opt-out dodatka za pregledač.' 
                : 'You can disable Google Analytics by installing the Google Analytics Opt-out Browser Add-on.'}
            </p>
            <p className="text-slate-600 dark:text-slate-400 mb-4">
              {language === 'sr' 
                ? 'Više informacija: ' 
                : 'More information: '}
              <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-amber-500 hover:underline">Google Privacy Policy</a>
            </p>

            <h2 className="text-xl font-semibold text-slate-900 dark:text-white mt-8 mb-4">
              {language === 'sr' ? '9. Čuvanje podataka' : '9. Data Retention'}
            </h2>
            <ul className="list-disc pl-6 text-slate-600 dark:text-slate-400 mb-4 space-y-2">
              <li>{language === 'sr' ? 'Dok je vaš nalog aktivan' : 'While your account is active'}</li>
              <li>{language === 'sr' ? 'Do 3 godine nakon deaktivacije naloga' : 'Up to 3 years after account deactivation'}</li>
              <li>{language === 'sr' ? 'Duže ako je to potrebno za zakonske obaveze ili rešavanje sporova' : 'Longer if required by law or for dispute resolution'}</li>
            </ul>

            <h2 className="text-xl font-semibold text-slate-900 dark:text-white mt-8 mb-4">
              {language === 'sr' ? '10. Vaša prava' : '10. Your Rights'}
            </h2>
            <p className="text-slate-600 dark:text-slate-400 mb-4">
              {language === 'sr' ? 'Imate pravo da:' : 'You have the right to:'}
            </p>
            <ul className="list-disc pl-6 text-slate-600 dark:text-slate-400 mb-4 space-y-2">
              <li>{language === 'sr' ? 'Pristupite svojim podacima koje obrađujemo' : 'Access the data we process about you'}</li>
              <li>{language === 'sr' ? 'Ispravite netačne podatke' : 'Correct inaccurate data'}</li>
              <li>{language === 'sr' ? 'Zatražite brisanje podataka ("pravo na zaborav")' : 'Request data deletion ("right to be forgotten")'}</li>
              <li>{language === 'sr' ? 'Ograničite obradu vaših podataka' : 'Restrict processing of your data'}</li>
              <li>{language === 'sr' ? 'Prenesete podatke drugom rukovaocu' : 'Transfer data to another controller'}</li>
              <li>{language === 'sr' ? 'Povučete pristanak u bilo kom trenutku' : 'Withdraw consent at any time'}</li>
              <li>{language === 'sr' ? 'Uložite prigovor Povereniku za informacije od javnog značaja' : 'File a complaint with the Commissioner for Information of Public Importance'}</li>
            </ul>

            <h2 className="text-xl font-semibold text-slate-900 dark:text-white mt-8 mb-4">
              {language === 'sr' ? '11. Bezbednost podataka' : '11. Data Security'}
            </h2>
            <ul className="list-disc pl-6 text-slate-600 dark:text-slate-400 mb-4 space-y-2">
              <li>{language === 'sr' ? 'SSL enkripcija za prenos podataka' : 'SSL encryption for data transmission'}</li>
              <li>{language === 'sr' ? 'Šifrovano čuvanje lozinki' : 'Encrypted password storage'}</li>
              <li>{language === 'sr' ? 'Redovno ažuriranje bezbednosnih sistema' : 'Regular security system updates'}</li>
              <li>{language === 'sr' ? 'Ograničen pristup podacima samo ovlašćenim licima' : 'Access limited to authorized personnel only'}</li>
            </ul>

            <h2 className="text-xl font-semibold text-slate-900 dark:text-white mt-8 mb-4">
              {language === 'sr' ? '12. Kontakt' : '12. Contact'}
            </h2>
            <p className="text-slate-600 dark:text-slate-400 mb-4">
              {language === 'sr' 
                ? 'Za sva pitanja u vezi sa privatnošću vaših podataka, kontaktirajte nas na:' 
                : 'For any privacy-related questions, contact us at:'}
            </p>
            <ul className="list-none text-slate-600 dark:text-slate-400 mb-4 space-y-1">
              <li>Email: kancelarija@svojnasvome.com</li>
              <li>{language === 'sr' ? 'Telefon' : 'Phone'}: +381 65 290 7002 (WhatsApp, Viber, SMS)</li>
              <li>Instagram: <a href="https://www.instagram.com/svet_nekretnina" target="_blank" rel="noopener noreferrer" className="text-amber-500 hover:underline">@svet_nekretnina</a></li>
            </ul>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
